module.exports = __webpack_public_path__ + "img/udyam-verification.dd28154c.svg";